
let language = {
    RETURN_REQUEST_TITLE: "Return Request",
    RETURN_REQUEST_ORDER: "Order No",
    RETURN_REQUEST_RETURN: "Return Item",
    RETURN_REQUEST_QUANTITY: "Quantity",
    RETURN_REQUEST_QTY: "Return Qty",
    RETURN_REQUEST_QTY_TIPS: "Please enter a valid quantity",
    RETURN_REQUEST_REASON: "Reason",
    RETURN_REQUEST_DESCRIPTION: "Description",
    RETURN_REQUEST_UPLOAD: "Upload Photos",
    RETURN_REQUEST_UPLOAD_TIPS: "You could upload 5 pictures,and one picture must under 50MB.(jpg,jpeg,png,gif,bmp,svg,pdf)",
    RETURN_REQUEST_SUBMITTED: "Fail upload pictures will not be submitted.",
    RETURN_REQUEST_UPLOAD_FAIL: "Upload Failed",
    RETURN_REQUEST_CANCEL: "Cancel",
    RETURN_REQUEST_COMFIRM: "Comfirm",
}

export { language }